import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export default function SuperAudit() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/platform/audit_logs").then(({ data }) => setItems(data)); }, []);
  return (
    <div className="space-y-6">
      <h1 className="font-display text-3xl font-bold">Audit logs</h1>
      <Card className="bg-slate-900 border-slate-800 p-0 overflow-hidden">
        <div className="divide-y divide-slate-800">
          {items.length === 0 ? (
            <div className="p-8 text-center text-slate-500 text-sm">No events yet.</div>
          ) : items.map((a) => (
            <div key={a.id} className="p-4 flex flex-wrap items-center gap-3 sm:gap-4 text-sm">
              <Badge className="bg-slate-800 border-slate-700 text-slate-300 font-mono-nums text-[10px]">{a.actor_kind}</Badge>
              <div className="flex-1 min-w-0"><div className="font-mono-nums text-slate-100 break-all">{a.action}</div><div className="text-xs text-slate-500 font-mono-nums break-all">{JSON.stringify(a.meta)}</div></div>
              <div className="text-xs text-slate-500 font-mono-nums w-full sm:w-auto">{new Date(a.created_at).toLocaleString("en-IN")}</div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
